import { DrawerProps } from '@mui/material';

import InboxDrawerContent from './InboxDrawerContent';

import RightDrawer from 'modules/common/components/RightDrawer/Drawer';
import { useIMCContext } from 'modules/IMC/common/context';
import { DrawerTypes } from 'modules/IMC/common/context/IMCContext.interface';

export default function InboxDrawer({ drawerProps = {} }: Readonly<{ drawerProps?: Omit<DrawerProps, 'open'> }>) {
    const { currOpenDrawer } = useIMCContext();

    return (
        <RightDrawer ariaLabel="Inbox" open={currOpenDrawer === DrawerTypes.INBOX} {...drawerProps}>
            <InboxDrawerContent />
        </RightDrawer>
    );
}
